// extracted by mini-css-extract-plugin
export default {"statsComponentWrapper":"statsComponentStyles_statsComponentWrapper__A1hHg","statsComponentInnerWrapper":"statsComponentStyles_statsComponentInnerWrapper__2son4"};